export default __webpack_public_path__ + "static/media/blog.5f12ae90.jpg";